<template>
	<div class="container">
		<div v-if="borrower">
			<div class="header">
				<div class="initials-circle">
					{{ borrower.initials }}
				</div>
				<h2>{{ borrower.fullName }}</h2>
			</div>
			<div class="item">
				<span class="label">Phone</span>
				<span class="dots"></span>
				<span class="value">{{ borrower.phoneNumber || 'N/A' }}</span>
			</div>
			<div class="item">
				<span class="label">Email</span>
				<span class="dots"></span>
				<span class="value">{{ borrower.emailAddress || 'N/A' }}</span>
			</div>
			<div class="item">
				<span class="label">SSN</span>
				<span class="dots"></span>
				<span class="value">{{ borrower.nationalIdNumberFormatted }}</span>
			</div>
			<div class="item">
				<span class="label">Birthdate</span>
				<span class="dots"></span>
				<span class="value">{{ borrower.dateOfBirthFormatted }}</span>
			</div>
			<div class="item">
				<span class="label">Address</span>
				<span class="dots"></span>
				<span class="value">{{ borrower.address }}</span>
			</div>
		</div>
		<div v-else class="no-borrower-message">
			<p>Loan does not have a Co-borrower</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Borrower } from '@/models/loans';
	import { defineProps } from 'vue';

	defineProps<{
		borrower: Borrower | null;
	}>();
</script>

<style scoped>
	.container {
		padding: 20px;
		width: 100%;
		height: 100%;
	}

	.header {
		display: flex;
		justify-self: left;
		align-items: baseline;
		height: 48px;
	}

	.initials-circle {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: black;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		font-weight: bold;
		margin-right: 10px;
	}

	.header h2 {
		font-size: 16px;
	}

	.item {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
		align-items: baseline;
	}

	.label {
		text-wrap: nowrap;
		color: #333;
	}

	.value {
		color: #777;
	}

	span.dots {
		flex-grow: 1;
		border-bottom: 1px dotted #ccc;
		margin: 0 5px;
	}

	.no-borrower-message {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #e2e4e9;
		color: #777;
		text-align: center;
		border: 1px dashed #ccc;
		border-radius: 4px;
		font-size: 16px;
	}
</style>
